module.exports = __webpack_public_path__ + "static/media/carSeat.40a7fc50.svg";